import React from "react";
import noimage from "../../../Resources/noimage.jpg";

export default function SustainableImagePanel({
    imageUrl,
    title,
    cellClassName,
    isEditing,
    inputValue,
    onPanelClick,
    onInputChange,
    onInputBlur,
    onInputKeyDown
}) {
    // 画像未設定時は既定の noimage を表示します。
    const src = imageUrl === "" ? noimage : imageUrl;

    return (
        <div className="kakousiji-sustainable-panel">
            <table className="kakousiji-sustainable-panel__table">
                <tbody>
                    <tr>
                        <td
                            key="sustainable-main"
                            className={cellClassName}
                            title={title}
                            onClick={onPanelClick}
                        >
                            {/* 編集中だけファイル名入力欄へ切り替えます。 */}
                            {isEditing ? (
                                <div
                                    className="kakousiji-sustainable-panel__editor"
                                    title={title}
                                    onClick={(event) => event.stopPropagation()}
                                >
                                    <input
                                        type="text"
                                        value={inputValue}
                                        className="kakousiji-sustainable-panel__input"
                                        autoFocus
                                        onClick={(event) => event.stopPropagation()}
                                        onChange={(event) => onInputChange(event.target.value)}
                                        onBlur={onInputBlur}
                                        onKeyDown={onInputKeyDown}
                                    />
                                </div>
                            ) : (
                                <div className="kakousiji-sustainable-panel__image-wrap">
                                    <img
                                        src={src}
                                        alt=""
                                        className="kakousiji-sustainable-panel__image"
                                    />
                                </div>
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
